"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "m 21.827379,18.032574 v 1.601317 c 0,1.211443 -0.982069,2.193511 -2.19351,2.193511 h -7.677286",
    id: "path6580",
    strokeWidth: "2",
    strokeMiterlimit: "4",
    strokeDasharray: "none"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M 11.956583,2.0858092 H 4.2792965 A 2.1935103,2.1935103 0 0 0 2.0857862,4.2793196 V 19.633891 a 2.1935103,2.1935103 0 0 0 2.1935103,2.193511 h 7.6772865",
    id: "path6578",
    strokeWidth: "2",
    strokeMiterlimit: "4",
    strokeDasharray: "none"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M 11.956583,2.0858092 V 21.827402",
    id: "path6564",
    strokeWidth: "2",
    strokeMiterlimit: "4",
    strokeDasharray: "none"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "m 21.826584,5.7046692 0.0026,-1.4185345 c 0.0022,-1.2086098 -0.979879,-2.1895701 -2.191871,-2.191036 l -7.680763,-0.00929",
    id: "path6580-8",
    strokeWidth: "2",
    strokeMiterlimit: "4",
    strokeDasharray: "none"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polyline", {
    transform: "matrix(0.45078567,0,0,0.45078567,12.996244,7.3765037)",
    points: "20 6 9 17 4 12",
    id: "polyline1636",
    strokeWidth: "4.43669844",
    strokeMiterlimit: "4",
    strokeDasharray: "none"
  })]
}));